/* Alert banner, one line (Jenny 2026-10-01, "on phone, resize it to 1 line,
   have it scroll horizontally if need to"). When the message is wider than
   its box, a copy is added after it and the pair slides left in a seamless
   loop. When it fits, nothing moves. Rechecked on resize. Under reduced
   motion custom.css stops the slide and the box can be swiped instead. */
(function () {
  var SPEED = 28; /* px per second, slow enough to read (was 40, Jenny 2026-10-06: "a bit slower") */
  var GAP = 48; /* px between the end of the message and its copy */

  function setup(box) {
    var track = box.querySelector('.fj-alert__track');
    var text = box.querySelector('.fj-alert__text');
    if (!track || !text) return;

    function check() {
      var copy = track.querySelector('.fj-alert__text--copy');
      if (copy) copy.remove();
      box.classList.remove('is-marquee');

      if (text.scrollWidth <= box.clientWidth) return;

      copy = text.cloneNode(true);
      copy.classList.add('fj-alert__text--copy');
      copy.setAttribute('aria-hidden', 'true');
      /* The copy's links stay clickable but out of the Tab order. */
      copy.querySelectorAll('a, button').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      track.appendChild(copy);
      var distance = text.offsetWidth + GAP;
      box.style.setProperty('--fj-alert-gap', GAP + 'px');
      box.style.setProperty('--fj-alert-distance', distance + 'px');
      box.style.setProperty('--fj-alert-duration', (distance / SPEED) + 's');
      box.classList.add('is-marquee');
    }

    check();
    var width = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === width) return; /* phone toolbars resize height only */
      width = window.innerWidth;
      check();
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
  }

  function init() {
    document.querySelectorAll('.fj-alert__message').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
